import { createContext, MutableRefObject } from 'react';

import { openCloseStates } from '../../hooks/useTransitionState';

interface AppShellContextValue {
  navOpen: boolean;
  navState: typeof openCloseStates[keyof typeof openCloseStates];
  drawerOpen: boolean;
  setDrawerOpen: (open: boolean) => void;
  refocusEl: HTMLButtonElement | null;
  setRefocusEl: (el: HTMLButtonElement | null) => void;
  focusedImperatively: MutableRefObject<boolean>;
  headerEl: HTMLDivElement | null;
  previewTriggerRef: MutableRefObject<HTMLElement | null>;
}

export type DrawerContent = 'notifications' | 'recents';

const AppShellContext = createContext<AppShellContextValue>({
  navOpen: false,
  navState: 'closed',
  drawerOpen: false,
  setDrawerOpen: () => {},
  refocusEl: null,
  setRefocusEl: () => {},
  focusedImperatively: {
    get current() {
      return false;
    }
  },
  headerEl: null,
  previewTriggerRef: {
    get current() {
      return null;
    },
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    set current(val) {}
  }
});

export default AppShellContext;
